/**
 * The circuits lane (2026-09-15, Polly: "can we show the circuits differently than the elements"):
 * each drawn circuit gets its own hue, spaced by the golden angle so neighbours never share one,
 * and every element it claims is painted in it; an element no circuit claims fades to the ground.
 */
import type { components } from '../../api';

export type CircuitsView = components['schemas']['CircuitsView'];
export type CircuitView = components['schemas']['CircuitView'];

/** The golden angle in degrees: successive hues land far apart however many circuits there are. */
const GOLDEN_ANGLE = 137.508;

/** The hue of the circuit at `index`, as a CSS colour. */
export function circuitColor(index: number): string {
  return `hsl(${(index * GOLDEN_ANGLE) % 360} 70% 55%)`;
}

/** Each member element's circuit index, so the canvas asks in O(1). */
export function circuitIndexOf(view: CircuitsView | null | undefined): Map<string, number> {
  const index = new Map<string, number>();
  view?.circuits.forEach((circuit, i) => {
    for (const member of circuit.members) if (!index.has(member)) index.set(member, i);
  });
  return index;
}

/** What the key prints for a circuit: its name, or its id when the file left it unnamed. */
export function circuitLabel(circuit: CircuitView, index: number): string {
  return circuit.name || `circuit ${index + 1} (${circuit.origin_id.slice(0, 8)})`;
}
